import React, { useState, useEffect, useRef } from 'react';

// react component for creating dynamic tables
import ReactTable from "react-table";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

// Table Data
import columns from 'tables/columns/settlements.json';
import { getTrips, formatTrips } from 'tables/rows/trips';
import { getSettlements, formatSettlements } from 'tables/rows/settlements';

const pathToType = {
    alltrips: undefined,
    otrtrips: 'OTR',
    brokertrips: 'Broker',
    localtrips: 'Local'
};

const TripsTable = () => {
    const tableNode = useRef(null);
    const [trips, setTrips] = useState([]);
    const [financials, setFinancials] = useState({
        revenue: 0,
        expenses: 0,
        cmTotal: 0,
        cmPercent: 0
    });
    const [getAll, setGetAll] = useState(false);

    const getTableTrips = (limited = true) => {
        getSettlements(pathToType[window.location.pathname.split('/')[2]], limited)
            .then(formatSettlements)
            .then(setTrips);
    }

    const getAllTrips = () => {
        setGetAll(true);
        getTableTrips(false);
    }

    const getFinancialData = () => {
        const filteredTable = tableNode.current.getResolvedState().sortedData;

        const remCommas = dollarValue => dollarValue.replace(/\$|,/g, '');
        const commaFy = (dollarValue) => dollarValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        let revenue = 0;
        let expenses = 0;

        for (let i = 0; i < filteredTable.length; i++) {
            if (filteredTable[i].totalRevenue) revenue += parseFloat(remCommas(typeof filteredTable[i].totalRevenue === 'string' ? filteredTable[i].totalRevenue : filteredTable[i].totalRevenue.toString()));
            if (filteredTable[i].tripRate) expenses += parseFloat(remCommas(typeof filteredTable[i].tripRate === 'string' ? filteredTable[i].tripRate : filteredTable[i].tripRate.toString()));
        }


        revenue = revenue.toFixed(2);
        expenses = expenses.toFixed(2);
        const contribution = (revenue - expenses).toFixed(2);
        const contributionPercent = ((contribution / revenue) * 100).toFixed(2);

        setFinancials({
            revenue: commaFy(revenue),
            expenses: commaFy(expenses),
            contribution: commaFy(contribution),
            contributionPercent
        })
    }

    useEffect(() => {
        if (trips.length) setTrips([]);
        
        getTableTrips();
    }, [window.location.pathname]);

    useEffect(() => {
        getFinancialData();
    }, [trips]);

    return (
        <GridContainer>
            <GridItem xs={6} sm={3}>
                <GridContainer justify='center'>
                    <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                            Filtered Revenue
                        </h5>
                    </GridItem>
                    <GridItem xs={12}>
                        <p style={{ textAlign: 'center', color: 'limegreen' }}>
                            $ {financials.revenue}
                        </p>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem xs={6} sm={3}>
                <GridContainer justify='center'>
                    <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                            Filtered Expenses
                        </h5>
                    </GridItem>
                    <GridItem xs={12}>
                        <p style={{ textAlign: 'center', color: 'red' }}>
                            $ {financials.expenses}
                        </p>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem xs={6} sm={3}>
                <GridContainer justify='center'>
                    <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                            Filtered Contribution
                        </h5>
                    </GridItem>
                    <GridItem xs={12}>
                        <p style={{ textAlign: 'center', color: 'limegreen' }}>
                            $ {financials.contribution}
                        </p>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem xs={6} sm={3}>
                <GridContainer justify='center'>
                    <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                            Filtered Contribution Percent
                        </h5>
                    </GridItem>
                    <GridItem xs={12}>
                        <p style={{ textAlign: 'center' }}>
                            {financials.contributionPercent} %
                        </p>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem xs={12}>
                {getAll ? null : (
                    <Button
                        color='primary'
                        onClick={getAllTrips}
                    >
                        GET ALL SETTLEMENTS
                    </Button>
                )}
                <ReactTable
                    ref={tableNode}
                    data={trips}
                    filterable
                    columns={columns.columns}
                    defaultPageSize={50}
                    defaultFilterMethod={(filter, row) => {
                        const id = filter.pivotId || filter.id;
                        return (
                            row[id] !== undefined ?
                                (String(row[id]).toLowerCase()).includes(filter.value.toLowerCase())
                                :
                                true
                        );
                    }}
                    onFilteredChange={getFinancialData}
                    style={{
                        color: "#000"
                    }}
                    defaultSorted={[
                        {
                            id: 'tripNumber',
                            desc: true
                        }
                    ]}
                    className="-striped -highlight"
                />
            </GridItem>
        </GridContainer>
    );
}

export default TripsTable;


// WEBPACK FOOTER //
// ./src/views/Settlements/SettlementsTable.jsx